import React from "react"
import { ReactComponent as CheckIcon } from "images/icons/check-thick.svg"
import { ReactComponent as XmarkIcon } from "images/icons/xmark-thick.svg"
import { Section, StatusContainer } from "./CustomerOrderTable.styled"
import { Tooltip } from "react-tooltip"
import { formatOperation } from "../Order/helpers"

type Props = {
  blockingOperations: (string | null | undefined)[]
  orderId: string
}

const Status = ({ blockingOperations, orderId }: Props) => {

  return (
    <Section>
      <Tooltip id={orderId}>
        {blockingOperations.length > 0 ? <div>{blockingOperations?.map((operation) => <div key={operation}>{formatOperation(operation ?? "")}</div>)}</div>: <div>No blocking operations</div>}
      </Tooltip>
      <StatusContainer $blocked={blockingOperations.length > 0} data-tooltip-id={orderId}>
        {blockingOperations.length > 0 ? <XmarkIcon /> : <CheckIcon />}
      </StatusContainer>
    </Section>
  )
}

export default Status
